/* =========================================================
   Sports n deco — Rendu LIVE "plaque de col" (navigateur)
   Compose le texte + data + perso sur une image de fond (propre/sale).
   API : SNPlaque.render(data, opts) -> string SVG
     data : { name, alt, pct, km, dplus, side, region, ref }
     opts : { style:'propre'|'sale', baseHref, dedic, date, chrono, showData }
   ========================================================= */
(function () {
  const PW = 800, PH = 1071;
  const STYLES = {
    propre: { bandTop: 0.022, bandBot: 0.280, faceL: 0.033, faceR: 0.967, halo: 0 },
    sale:   { bandTop: 0.020, bandBot: 0.269, faceL: 0.035, faceR: 0.963, halo: 0.30 },
  };
  const INK = '#1c1b18', SUB = '#2c2a26', LABEL = '#6e543c', RUST = '#8a5a34';

  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function frnum(n){ return Number(n).toLocaleString('fr-FR'); }

  function splitName(name){
    const m = String(name).match(/^(Col du|Col de la|Col de|Col des|Col d'|Mont|Cime de la|Passo dello|Passo della|Passo di|Passo|Alto de|Alto del|Colle del|Colle)\s*(.*)$/i);
    if (m && m[2]) return [m[1].toUpperCase(), m[2].toUpperCase()];
    return ['', String(name).toUpperCase()];
  }

  // texte centré sur (x, cyFrac*PH) — dominant-baseline central = équiv. anchor "mm" Pillow
  function T(x, cyFrac, txt, sizeFrac, weight, fill, spacing){
    return `<text x="${x.toFixed(1)}" y="${(cyFrac*PH).toFixed(1)}" font-size="${(sizeFrac*PH).toFixed(1)}" font-weight="${weight}" fill="${fill}" text-anchor="middle" dominant-baseline="central"${spacing?` letter-spacing="${spacing}"`:''}>${esc(txt)}</text>`;
  }

  function render(data, opts){
    opts = opts || {};
    const st = STYLES[opts.style] || STYLES.propre;
    const cx = PW/2;
    const faceW = (st.faceR - st.faceL) * PW;
    const maxW = faceW * 0.90;

    // halo lisibilité (version sale)
    let halo = '';
    if (st.halo > 0) halo = `<rect x="${(PW*0.10).toFixed(0)}" y="${(PH*0.33).toFixed(0)}" width="${(PW*0.80).toFixed(0)}" height="${(PH*0.57).toFixed(0)}" rx="${(PW*0.03).toFixed(0)}" fill="#f7f3ec" opacity="${st.halo}"/>`;

    // numéro de route (bande jaune)
    const roadY = (st.bandTop + st.bandBot) / 2;
    const road = opts.ref ? T(cx, roadY, opts.ref, 0.108, 700, INK, 3) : '';

    // corps blanc
    const [prefix, name] = splitName(data.name);
    let nameSize = 0.090;
    const estW = name.length * 0.54 * (nameSize * PH);
    if (estW > maxW) nameSize = nameSize * maxW / estW;

    const body =
        T(cx, 0.358, `Sommet alt. ${frnum(data.alt)} m`, 0.036, 500, SUB)
      + (prefix ? T(cx, 0.440, prefix, 0.040, 600, INK, 2) : '')
      + T(cx, 0.520, name, nameSize, 700, INK, 1)
      + T(cx, 0.650, `Pente à : ${String(data.pct).replace('.', ',')} %`, 0.036, 500, SUB);

    // séparateur + NOTRE data
    const divY = 0.705 * PH;
    const dataBlock =
        `<line x1="${(PW*0.11).toFixed(0)}" y1="${divY.toFixed(0)}" x2="${(PW*0.89).toFixed(0)}" y2="${divY.toFixed(0)}" stroke="${RUST}" stroke-width="1.4" opacity="0.55"/>`
      + T(PW*0.275, 0.755, `${String(data.km).replace('.', ',')} km`, 0.033, 600, INK)
      + T(PW*0.275, 0.784, 'DISTANCE', 0.015, 600, LABEL, 2)
      + T(PW*0.725, 0.755, `${frnum(data.dplus)} m`, 0.033, 600, INK)
      + T(PW*0.725, 0.784, 'DÉNIVELÉ +', 0.015, 600, LABEL, 2);

    // ZONE PERSO : datas du client si fournies, sinon versant · région par défaut
    const dedic = (opts.dedic || '').trim().toUpperCase();
    const date  = (opts.date  || '').trim().toUpperCase();
    const chrono= (opts.chrono|| '').trim().toUpperCase();
    let perso;
    if (dedic || date || chrono) {
      const line2 = [date, chrono].filter(Boolean).join('  ·  ');
      perso = (dedic ? T(cx, 0.828, dedic, 0.022, 700, INK, 2) : '')
            + (line2 ? T(cx, dedic ? 0.868 : 0.845, line2, 0.019, 600, LABEL, 3) : '');
    } else {
      perso = T(cx, 0.850, `DEPUIS ${String(data.side).toUpperCase()} · ${String(data.region).toUpperCase()}`, 0.0185, 600, LABEL, 3);
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Oswald','Arial Narrow','Inter',sans-serif">
<image href="${opts.baseHref}" x="0" y="0" width="${PW}" height="${PH}" preserveAspectRatio="xMidYMid slice"/>
${halo}${road}${body}${dataBlock}${perso}
</svg>`;
  }

  window.SNPlaque = { render, STYLES, PW, PH };
})();
